import { observable, action, makeObservable, set } from 'mobx';

import { PartnerBankAccountType } from '../../shared/support/modelTypes';

export interface PartnerBankAccountFormStoreType {
	model: PartnerBankAccountType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude?: Array<any>;
	selectedItems: Array<any>;
	isFirstLoad: boolean;
	name: string;
	setValue(model: any, key: string, value: any): void;
}

class PartnerBankAccountFormStore implements PartnerBankAccountFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			selectedItems: observable,
			isFirstLoad: observable,
			name: observable,
			setValue: action
		});
	}

	model = {
		bankCode: null,
		bankName: '',
		bankCorrAccount: null,
		bankCity: null,
		bankAddress: null,
		bankPhone: null,
		bankSwiftCode: null,
		bankItn: null,
		accountNumber: '',
		correspondentText: null,
		destinationText: null,
		bankBIC: null,
		name: { ru: '' },
		displayName: null,
		priority: null,
		deleted: false,
		ownerId: null,
		ownerType: null
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	pluralName = 'partnerBankAccounts';
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	isFirstLoad = true;
	name = 'OrmPartnerBankAccount';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const partnerBankAccountFormStore = new PartnerBankAccountFormStore();

export default PartnerBankAccountFormStore;
